//@flow

import env from '../../../../environment';
import {getCreator, putCreator} from '../../../../http';

export const endpoints = Object.freeze({
  SAVE_PROMOTION: `${env.baseApiUrl}/im/admin/delivery/shipping-method`,
  GET_PROMOTIONS: `${env.baseApiUrl}/im/admin/delivery/shipping-method`,
  DELETE_PROMOTION: `${env.baseApiUrl}/im/admin/delivery/shipping-method`,
  UPDATE_PROMOTION: `${env.baseApiUrl}/im/admin/delivery/shipping-method`,
});

export const getLogisticPromotionsApi = getCreator(endpoints.GET_PROMOTIONS);
export const savePromotionApi = putCreator(endpoints.SAVE_PROMOTION);
export const updatePromotionApi = putCreator(endpoints.UPDATE_PROMOTION);
export const deletePromotionApi = putCreator(endpoints.DELETE_PROMOTION);
// export const edit = putCreator(endpoints.EDIT_);
// export const deletee = deleteCreator(endpoints.DELETE_);
